module.exports = (window.__NEXT_DATA__.assetPrefix || "").replace(/\/$/, "") + "/_next/static/images/404-explorers-11c36eca7027260ec4ea2b1b5ee66c54.png";